import { createContext, useContext } from 'react'

import type { FooterItem } from '../components/ul-footer'
import type { ULStepName } from '../constants/ul-config'

export interface UploadLeadsFooterConfig {
  buttonText?: string
  buttonVariant?: 'default' | 'ghost'
  isPrimaryDisabled?: boolean
  primaryAction?: () => void
  bottomLeftContent?: FooterItem
}

interface UploadLeadsContextType {
  /** @param skip - The number of steps to skip. Default is 0. */
  handleNext: (skip?: number) => void
  handleGoToStep: (step: ULStepName) => void
  handleBack: () => void
  /** Can be called inside each step to set the footer config */
  setFooterConfig: (config: UploadLeadsFooterConfig | null) => void
}

export const UploadLeadsContext = createContext<UploadLeadsContextType>({
  handleNext: () => {},
  handleGoToStep: () => {},
  handleBack: () => {},
  setFooterConfig: () => {},
})

export const useUploadLeadsContext = () => {
  const context = useContext(UploadLeadsContext)
  if (!context) {
    throw new Error('useUploadLeadsContext must be used within a UploadLeadsContextProvider')
  }
  return context
}
